import AppointmentTypeRegistration from './main';
import { connect } from 'react-redux';
import { turnsActions } from 'core/Turns';

const mapStateToProps = ({
    option: {
        specialties
    },
    turns: {
        appointmentType
    }
}) => ({
    appointmentType,
    specialties
});

const mapDispatchToProps = {
    createAppointmentType: turnsActions.createAppointmentType,
    deleteAppointmentType: turnsActions.deleteAppointmentType,
    getAppointmentType: turnsActions.getAppointmentType,
    setTurnsAppointmentType: turnsActions.setTurnsAppointmentType,
    updateAppointmentType: turnsActions.updateAppointmentType
};

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentTypeRegistration);
